import { environmentDefaults } from './environment-defaults';
import * as defaultsDeep from 'lodash.defaultsdeep';
import { API_ENDPOINTS } from './api-endpoints';

const override = {
  PERFORM_APP_DYNAMICS: API_ENDPOINTS.PERFORM_APP_DYNAMICS.QA,
  hostname: API_ENDPOINTS.HOSTNAME.QA,
  RTI_ENDPOINT: API_ENDPOINTS.RTI_ENDPOINT.QA,
  RTI_X_API_VALUE: API_ENDPOINTS.RTI_X_API_VALUE.QA,
  RTI_X_API_KEY: API_ENDPOINTS.RTI_X_API_KEY.COMMON,
  PP_ENDPOINT: API_ENDPOINTS.PP_ENDPOINT.QA,
  APP_DYNAMIC_KEY: API_ENDPOINTS.APP_DYNAMIC_KEY.QA,
  DIS_ENDPOINT: API_ENDPOINTS.DIS_ENDPOINT.QA,
  DIS_X_API_VALUE: API_ENDPOINTS.DIS_X_API_VALUE.QA,
  DIS_X_API_KEY: API_ENDPOINTS.DIS_X_API_KEY.COMMON,
  CREDIT_APP_ENPOINT:API_ENDPOINTS.CREDIT_APP_ENPOINT.QA,
  GOOGLE_MAP_API_KEY: API_ENDPOINTS.GOOGLE_MAP_API_KEY.QA,
  WAF_URL: API_ENDPOINTS.WAF_URL.QA,
};

export const environment = defaultsDeep(override, environmentDefaults);
